import { render } from "./patient-list.vue?vue&type=template&id=5ebd02aa&scoped=true"
import script from "./patient-list.vue?vue&type=script&lang=js"
export * from "./patient-list.vue?vue&type=script&lang=js"

import "./patient-list.vue?vue&type=style&index=0&id=5ebd02aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebd02aa"]])

export default __exports__